import { z } from "zod";

/**
 * KAPASİTE MUTABAKATI KONFİGİ (CLOS-828 · CLOS-198 `[068]`).
 *
 * ⚠ Sıklık neden konfigde: "ne kadar sürelik sayaç sapmasına tahammül ediyoruz" bir ürün
 * kararı, kod dalı değil. Sapma birikirse kullanıcı gerçekte dolu olmayan bir kapasite
 * yüzünden duvara toslar; toleransı ürün sahibi belirlemeli (kriter 19).
 *
 * ⚠ `version` `literal` ile kilitli: bilinmeyen bir konfig sürümü açılışta reddediliyor.
 * Sessizce varsayılana düşseydi, yanlış yazılmış bir konfig fark edilmeden yürürlükte
 * kalırdı.
 */
export const contractCapacityConfigSchema = z.object({
  version: z.literal(1),
  reconciliation: z.object({
    /**
     * Cron ifadesi — dakika cinsinden bir sayı DEĞİL.
     *
     * ⚠ İlk yazımda dakika sayısıydı ve cron ifadesine kod içinde çevriliyordu.
     * 60'tan büyük her değer sessizce yanlış çalışıyordu: cron'un dakika
     * alanı 0-59, yani "her 360 dakikada bir" diye yazılan ifade "altı saatte bir" değil
     * SAATTE BİR tetikliyor. Ayrıştırıcı hata da vermiyor (ölçüldü) — tam olarak sessizce
     * yanlış çalışan mekanizma sınıfı.
     */
    cron: z.string().trim().min(9).max(64),
  }),
});

export type ContractCapacityConfig = z.infer<typeof contractCapacityConfigSchema>;
